<template lang="pug">
.sv-calendar
    .sv-calendar__header
        button.sv-calendar__arrow(
            @click="prev"
            @mouseover="over('left', true)"
            @mouseleave="over('left', false)"
        )
            SvIcon(
                icon="arrow-left"
                :width="15"
                :height="15"
                :stroke="strokeColorLeft"
            )

        span.sv-calendar__month
            | {{ getCurrentMonthYear }}

        button.sv-calendar__arrow(
            @click="next"
            @mouseover="over('right', true)"
            @mouseleave="over('right', false)"
        )
            SvIcon(
                icon="arrow-left"
                :width="15"
                :height="15"
                :stroke="strokeColorRight"
            )

    .sv-calendar__body
        .sv-calendar__week
            .sv-calendar__weekday(
                v-for="day in weeks"
                :key="day"
            )
                | {{ day }}

        .sv-calendar__month-date
            .sv-calendar__circle(
                v-for="day in calendar"
                :class="{ 'sv-calendar__circle--today': isToday(day) }"
                @click="change(day)"
            )
                .sv-calendar__day
                    | {{ day || '' }}
</template>

<script>
import SvIcon from '@/components/uikit/SvIcon.vue';

export default {
  name: 'SvCalendar',

  components: {
    SvIcon,
  },

  data() {
    return {
      currentMonth: null,
      currentYear: null,
      isOver: null,
      weeks: ['пн', 'вт', 'ср', 'чт', 'пт', 'сб', 'вс'],
      months: [
        'январь',
        'февраль',
        'март',
        'апрель',
        'май',
        'июнь',
        'июль',
        'август',
        'сентябрь',
        'октябрь',
        'ноябрь',
        'декабрь',
      ],
    };
  },

  beforeMount() {
    this.currentMonth = new Date().getMonth();
    this.currentYear = new Date().getFullYear();
  },

  computed: {
    calendar() {
      return this.getMatrixCalendar(this.currentMonth, this.currentYear);
    },

    getCurrentMonthYear() {
      return `${this.months[this.currentMonth]} ${this.currentYear}`;
    },

    strokeColorLeft() {
      return this.isOver === 'left' ? '#1993EB' : '#B7BAC6';
    },

    strokeColorRight() {
      return this.isOver === 'right' ? '#1993EB' : '#B7BAC6';
    },
  },

  methods: {
    change(day) {
      if (day === '') {
        return;
      }
      this.$emit('input', {
        year: this.currentYear,
        month: this.currentMonth + 1,
        day,
      });
    },

    isToday(day) {
      const month = new Date().getMonth();
      const year = new Date().getFullYear();
      const date = new Date().getDate();
      return month === this.currentMonth
                && year === this.currentYear
                && date === day;
    },

    prev() {
      const date = new Date(this.currentYear, this.currentMonth, 1);
      date.setMonth(date.getMonth() - 1);
      this.currentMonth = date.getMonth();
      this.currentYear = date.getFullYear();
    },

    next() {
      const date = new Date(this.currentYear, this.currentMonth, 1);
      date.setMonth(date.getMonth() + 1);
      this.currentMonth = date.getMonth();
      this.currentYear = date.getFullYear();
    },

    over(direction, status) {
      this.isOver = status ? direction : null;
    },

    getMatrixCalendar(month, year) {
      const result = [];
      const dayInMonth = this.daysInMonth(month, year);
      for (let i = 1; i <= dayInMonth; i += 1) {
        result.push(i);
      }

      const firstDay = this.firstWeekDayOfMonth(month, year);
      for (let k = 0; k < firstDay; k += 1) {
        result.unshift(null);
      }

      return result;
    },

    firstWeekDayOfMonth(month, year) {
      const week = [6, 0, 1, 2, 3, 4, 5];
      const weekDay = new Date(year, month, 1).getDay();
      return week[weekDay];
    },

    daysInMonth(month, year) {
      return new Date(year, month + 1, 0).getDate();
    },
  },
};
</script>

<style lang="scss" scoped>
.sv-calendar {
    width: 310px;
    background: #FFFFFF;
    box-shadow: 0px 5px 20px rgba(3, 62, 105, 0.08);
    border-radius: 10px;
    padding: 22px 30px 27px 30px;

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-transform: uppercase;
        color: #404450;
        font-size: 16px;
        font-weight: bold;
    }

    &__week,
    &__month-date {
        display: grid;
        grid-template-columns: repeat(7, 1fr);
        justify-items: center;
        // grid-row-gap: 15px;
    }

    &__arrow {
        display: flex;
        outline: none;
        border: 0;
        padding: 0;
        margin: 0;
        width: 23px;
        height: 23px;
        border-radius: 3px;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        &:last-child {
            transform: rotate(180deg);
        }
    }

    &__body {
        margin: 18px -6px 0 -6px;
    }

    &__circle {
        width: 28px;
        height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        color: #404450;
        cursor: pointer;

        &--today,
        &:hover {
            background-color: #F3F3F6;
        }

        &--today {
            color: #0882DB;
        }
    }

    &__day {
        font-size: 14px;
        font-weight: 500;
        position: relative;
    }

    &__week {
        margin-bottom: 5px;
    }

    &__weekday {
        text-transform: uppercase;
        font-size: 14px;
        font-weight: bold;
        color: #ADB2C0;

        &:nth-of-type(6),
        &:nth-of-type(7) {
            color: #D74848;
        }
    }
}
</style>
